module.exports = __webpack_public_path__ + "img/map-tree.0228e702.png";